import axios from 'axios';

import responseMessageHandler from './responseMessageHandler';

import {
  URL_GET_EXIST_REPORT_BY_ID,
  URL_SUBSCRIPTION
} from './urlUtils/subscription';

export function editSubscription (id, dateTimeFinish): Promise<any> {
  return axios.put(URL_SUBSCRIPTION, {
    'subscription_id': id,
    'datetime_finish' : dateTimeFinish,
  }).catch(err => Promise.reject(handleErrorResponse(err)));
}

export function deleteExistSubscription (id): Promise<any> {
  return axios.patch(URL_SUBSCRIPTION,
    { 'subscription_id': id })
    .catch(err => Promise.reject(handleErrorResponse(err)));
}

export function sendSubscriptionForm (finishedForm): Promise<any> {
  return axios.post(URL_SUBSCRIPTION, finishedForm)
    .catch(err => Promise.reject(handleErrorResponse(err)));
}

export function subscriptionGetById (authIdInputValue): Promise<any> {
  return axios.get(URL_GET_EXIST_REPORT_BY_ID(authIdInputValue))
    .catch(err => Promise.reject(handleErrorResponse(err)));
}

export function subscriptionGet (): Promise<any> {
  return axios.get(URL_SUBSCRIPTION);
}

function handleErrorResponse (reason): string {
  if (reason && reason.response && reason.response.data && reason.response.data.message) {
    return responseMessageHandler(reason.response.data.message);
  }
  return 'Error';
}
